import * as fieldActions from '../../Common/actions/Field';
import {getFieldPack} from './Packages';
import {getLocalizedText, texts} from '../../../../constants/TextConst';

/* change field title */

export function startTitleEdit(field) {
    fieldActions.startTitleEdit(field);
    field.parentCollection.setActive(null);
}

export function changeTitle(field, newTitle, cancelCallback) {
    fieldActions.changeTitle(field, newTitle, cancelCallback, getLocalizedText(texts.doubleTab));
}

/* hide */

export function isHideDisabled(field) {
    const activeFieldPack = getFieldPack(field);
    return (activeFieldPack && activeFieldPack.moduleHidden) || field.isHiddenStatusUnchangable;
}
